import Vue from 'vue'
import Router from 'vue-router'
import store from './store'


import FindPlans from './views/FindPlans.vue'
import LogInView from './views/LogInView.vue'
import ResetPasswordView from './views/ResetPasswordView.vue'
import ViewPlan from './views/ViewPlan.vue'
import AppointmentSelect from './views/AppointmentSelect.vue'
// import AppointmentEncounterType from './views/AppointmentEncounterType.vue'
import AppointmentFlow from './views/AppointmentFlow.vue'
import AppointmentSetup from './views/AppointmentSetup.vue'
import AppointmentPost from './views/AppointmentPost.vue'
import AppointmentTreatSummary from './views/AppointmentTreatSummary.vue'
// import EncounterView from './views/EncounterView.vue'
// import Encounter_tpGoal from './views/Encounter_tpGoal.vue'
// import Encounter_tpProblem from './views/Encounter_tpProblem.vue'
// import Encounter_tpChart from './views/Encounter_tpChart.vue'
// import Encounter_tpAdvancing from './views/Encounter_tpAdvancing.vue'
// import Encounter_tpRebuilding from './views/Encounter_tpRebuilding.vue'
// import Encounter_tpProtection from './views/Encounter_tpProtection.vue'
// import Encounter_tpSavings from './views/Encounter_tpSavings.vue'
// import Encounter_tpSchedule from './views/Encounter_tpSchedule.vue'
// import Encounter_Post from './views/Encounter_Post.vue'
import StatsView from './views/StatsView.vue'
import StatsSnapshotView from './views/StatsSnapshotView.vue'
import StatsPathToHealthView from './views/StatsPathToHealthView.vue'
import PatientOutreachView from './views/PatientOutreachView.vue'
import PatientListView from './views/PatientListView.vue'
import PatientDetailView from './views/PatientDetailView.vue'
import TeamView from './views/TeamView.vue'

Vue.use(Router)

const routes = [
  // Public
  // ----------
  {
    path: '/log-in',
    name: 'logIn',
    component: LogInView,
    meta: {
      pageTitle: 'Log In',
    }
  },
  // {
  //   path: '/sign-up',
  //   name: 'signUp',
  //   component: SignUpView,
  //   meta: {
  //     pageTitle: 'Sign Up',
  //   }
  // },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: ResetPasswordView,
    meta: {
      pageTitle: 'Reset Password',
    }
  },
  
  // --------------------
  // Private
  // --------------------
  {
    path: '/',
    name: 'findPlans',
    component: FindPlans,
    meta: {
      pageTitle: 'Find Patient Treatment Plans',
      authRequired: true,
    }
  },
  {
    path: '/treatment-plan',
    name: 'viewPlan',
    component: ViewPlan,
    meta: {
      pageTitle: 'View Treatment Plan',
      authRequired: true,
    }
  },
  {
    path: '/appointments',
    name: 'appointmentSelect',
    component: AppointmentSelect,
    meta: {
      pageTitle: "Today's Appointments",
      authRequired: true,
    }
  },
    // {
    //   path: '/appointment-encounter-type',
    //   name: 'appointmentEncounterType',
    //   component: AppointmentEncounterType,
    //   meta: {
    //     pageTitle: "Appointment Encounter Type",
    //     authRequired: true,
    //   }
    // },
  
  {
    path: '/appointment',
    name: 'appointmentFlow',
    component: AppointmentFlow,
    meta: {
      pageTitle: "Appointment",
      authRequired: true,
    },
    children: [
      {
        path: '/appointment/setup',
        name: 'appointmentSetup',
        component: AppointmentSetup,
        meta: {
          pageTitle: "Appointment Setup",
          authRequired: true,
        }
      },
      {
        path: '/appointment/treatment-summary',
        name: 'appointmentTreatSummary',
        component: AppointmentTreatSummary,
        meta: {
          pageTitle: "Appointment Treatment Summary",
          authRequired: true,
        },
        // children: [
        //   {
        //     path: '/appointment/treatment-summary/encounter-type',
        //     name: 'appointmentEncounterType',
        //     component: AppointmentEncounterType,
        //     meta: {
        //       pageTitle: "Appointment Encounter Type",
        //       authRequired: true,
        //     }
        //   },
        // ]
      },
      {
        path: '/appointment/after',
        name: 'appointmentPost',
        component: AppointmentPost,
        meta: {
          pageTitle: "Post-Appointment Tasks",
          authRequired: true,
        }
      },
    ]
  },
  {
    path: '/stats',
    name: 'stats',
    component: StatsView,
    meta: {
      pageTitle: "Stats",
      authRequired: true,
    },
    children: [
      {
        path: '',
        redirect: {name: 'statsSnapshot'},
      },
      {
        path: '/stats/snapshot',
        name: 'statsSnapshot',
        component: StatsSnapshotView,
        meta: {
          pageTitle: "Stats Snapshot",
          authRequired: true,
        }
      },
      {
        path: '/stats/path-to-health',
        name: 'statsPathToHealth',
        component: StatsPathToHealthView,
        meta: {
          pageTitle: 'Path to Health Stats',
          authRequired: true,
        }
      },
    ]
  },
  {
    path: '/patient-outreach',
    name: 'patientOutreach',
    component: PatientOutreachView,
    meta: {
      pageTitle: 'Patient Outreach',
      authRequired: true,
    },
    children: [
      {
        path: '',
        redirect: {name: 'patientOutreachUnscheduled'},
      },
      {
        path: '/patient-outreach/unscheduled',
        name: 'patientOutreachUnscheduled',
        component: PatientListView,
        meta: {
          pageTitle: 'Unscheduled Patients',
          patientListMode: 'active',
          authRequired: true,
        }
      },
      {
        path: '/patient-outreach/all',
        name: 'patientOutreachAll',
        component: PatientListView,
        meta: {
          pageTitle: 'All Patients',
          patientListMode: 'all',
          authRequired: true,
        }
      },
      {
        path: '/patient-outreach/snoozed',
        name: 'patientOutreachSnoozed',
        component: PatientListView,
        meta: {
          pageTitle: 'Snoozed Patients',
          patientListMode: 'snoozed',
          authRequired: true,
        }
      },
      {
        path: '/patient-outreach/completed',
        name: 'patientOutreachCompleted',
        component: PatientListView,
        meta: {
          pageTitle: 'Completed Patients',
          patientListMode: 'completed',
          authRequired: true,
        }
      },
      {
        path: '/patient-outreach/scheduled',
        name: 'patientOutreachScheduled',
        component: PatientListView,
        meta: {
          pageTitle: 'Scheduled Patients',
          patientListMode: 'scheduled',
          authRequired: true,
        }
      },
      {
        path: '/patient-outreach/patient/:patNum',
        name: 'patientDetail',
        component: PatientDetailView,
        meta: {
          pageTitle: 'Patient Detail',
          authRequired: true,
        }
      },
    ]
  },
  {
    path: '/team',
    name: 'team',
    component: TeamView,
    meta: {
      pageTitle: 'Team',
      authRequired: true,
    }
  },
  // {
  //   path: '/encounter',
  //   name: 'encounterView',
  //   component: EncounterView,
  //   meta: {
  //     pageTitle: "Encounter View",
  //     authRequired: true,
  //   },
  //   children: [
  //     {
  //       path: '/encounter/treatment-plan-goal',
  //       name: 'tp_Goal',
  //       component: Encounter_tpGoal,
  //       meta: {
  //         pageTitle: 'Treatment Plan - Goal',
  //         authRequired: true,
  //         encounterOrder: 1,
  //       },
  //     },
  //     {
  //       path: '/encounter/treatment-plan-problem',
  //       name: 'tp_Problem',
  //       component: Encounter_tpProblem,
  //       meta: {
  //         pageTitle: 'Treatment Plan - Problem',
  //         authRequired: true,
  //         encounterOrder: 2,
  //       }
  //     },
  //     {
  //       path: '/encounter/treatment-plan-chart',
  //       name: 'tp_Chart',
  //       component: Encounter_tpChart,
  //       meta: {
  //         pageTitle: 'Treatment Plan - Chart',
  //         authRequired: true,
  //         encounterOrder: 3,
  //       },
  //     },
  //     {
  //       path: '/encounter/treatment-plan-advancing-disease-care',
  //       name: 'tp_Advancing',
  //       component: Encounter_tpAdvancing,
  //       meta: {
  //         pageTitle: 'Treatment Plan - Advancing Disease Care',
  //         authRequired: true,
  //         encounterOrder: 4,
  //       },
  //     },
  //     {
  //       path: '/encounter/treatment-plan-rebuilding-care',
  //       name: 'tp_Rebuilding',
  //       component: Encounter_tpRebuilding,
  //       meta: {
  //         pageTitle: 'Treatment Plan - Rebuilding Care',
  //         authRequired: true,
  //         encounterOrder: 5,
  //       },
  //     },
  //     {
  //       path: '/encounter/treatment-plan-protection-care',
  //       name: 'tp_Protection',
  //       component: Encounter_tpProtection,
  //       meta: {
  //         pageTitle: 'Treatment Plan - Protection Care',
  //         authRequired: true,
  //         encounterOrder: 6,
  //       },
  //     },
  //     {
  //       path: '/encounter/treatment-plan-savings',
  //       name: 'tp_Savings',
  //       component: Encounter_tpSavings,
  //       meta: {
  //         pageTitle: 'Treatment Plan - Savings',
  //         authRequired: true,
  //         encounterOrder: 7,
  //       },
  //     },
  //     {
  //       path: '/encounter/treatment-plan-sign',
  //       name: 'tp_Sign',
  //       component: ViewPlan,
  //       meta: {
  //         pageTitle: 'Treatment Plan - Sign',
  //         authRequired: true,
  //         encounterOrder: 8,
  //         fullPageSlide: true,
  //       },
  //     },
  //     {
  //       path: '/encounter/treatment-plan-schedule',
  //       name: 'tp_Schedule',
  //       component: Encounter_tpSchedule,
  //       meta: {
  //         pageTitle: 'Treatment Plan - Schedule',
  //         authRequired: true,
  //         encounterOrder: 9,
  //       },
  //     },
  //     {
  //       path: '/encounter/treatment-plan-post-appointment',
  //       name: 'tp_PostEncounter',
  //       component: Encounter_Post,
  //       meta: {
  //         pageTitle: 'Post Appointment',
  //         authRequired: true,
  //         encounterOrder: 10,
  //         hideInEncounterNav: true,
  //       },
  //     },
  //   ]
  // },
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  // always scroll to top of new page
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes
})

router.beforeEach((to, from, next) => {
  // if page requires authentication
  if ( to.matched.some(record => record.meta.authRequired) ) {
    // if no user, force login
    if (!store.state.user) {
      next({
        path: '/log-in',
        query: { redirect: to.fullPath }
      })
    }
    else {
      // console.log('passed route reqs')
      next()
    }
  }
  else {
    // console.log('no route reqs')
    next()
  }
})

// update page title
const DEFAULT_TITLE = 'why/care';
router.afterEach((to, from) => {
  if(to.meta.pageTitle) {
    document.title = `${to.meta.pageTitle} | ${DEFAULT_TITLE}`;
  } else {
    document.title = DEFAULT_TITLE;
  }
});

export default router
